export default __webpack_public_path__ + "static/media/dotIcon.a792d354.svg";